module.exports = __webpack_public_path__ + "img/04-main.459221a8.svg";